import React from 'react';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import SharedFeaturePageShell from '../../../components/shell/FeaturePageShell';
import LoadingState from '../../../components/kea/LoadingState';

/** Compatibility adapter: keep legacy loading and non-blocking errors in the shared FPS layout. */
const FeaturePageShell = ({ loading, error, children, ...props }) => (
  <SharedFeaturePageShell {...props}>
    {loading ? <LoadingState variant="page" testId="shell-loading" /> : (
      <>
        {error && <Box mb={3} data-testid="shell-error"><Alert severity="error">{error}</Alert></Box>}
        {children}
      </>
    )}
  </SharedFeaturePageShell>
);

export default FeaturePageShell;
